import { SingleColumnLayout } from '#components/SingleColumnLayout/SingleColumnLayout';

import styles from './Weather.module.scss';

export function WeatherError() {
	return (
		<SingleColumnLayout contentClassName={styles.contentLayout}>
			<h2 className="heading3">Es konnten keine Wetterdaten gefunden werden.</h2>
		</SingleColumnLayout>
	);
}
